import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ variant = 'default' }) => {
    const { i18n, t } = useTranslation('common');
    const currentLang = i18n.language?.substring(0, 2) || 'pl';

    const toggleLanguage = () => {
        const newLang = currentLang === 'pl' ? 'en' : 'pl';
        i18n.changeLanguage(newLang);
    };

    return (
        <button
            className={`language-switcher language-switcher--${variant}`}
            onClick={toggleLanguage}
            title={t('languageSwitcher.switchTo')}
            aria-label={t('languageSwitcher.switchTo')}
        >
            <span className={`language-switcher__option ${currentLang === 'pl' ? 'active' : ''}`}>PL</span>
            <span className="language-switcher__separator">/</span>
            <span className={`language-switcher__option ${currentLang === 'en' ? 'active' : ''}`}>EN</span>
        </button>
    );
};

export default LanguageSwitcher;
